import { atom } from "jotai";

import { LoaderTranslationKey } from "../pages/VehicleAnalysis/constants";

export const loaderTranslationKeyAtom = atom(LoaderTranslationKey.UploadingPhotos);
